import { render, staticRenderFns } from "./bulma_pictureviewer.vue?vue&type=template&id=1fc0f066&scoped=true"
import script from "./bulma_pictureviewer.vue?vue&type=script&lang=js"
export * from "./bulma_pictureviewer.vue?vue&type=script&lang=js"
import style0 from "./bulma_pictureviewer.vue?vue&type=style&index=0&id=1fc0f066&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0f066",
  null
  
)

export default component.exports